/**
 * Label chip — a coloured pill rendering the label name. Colour is
 * deterministic from the name (see `lib/label-color`). Optional ×
 * removes the label inline (used inside the LabelDropdown row hover
 * area; not on the table cell where the column would get noisy).
 */

import { labelColors } from "@/lib/label-color";

export function LabelChip({
  name,
  onRemove,
}: {
  name: string;
  onRemove?: () => void;
}) {
  const c = labelColors(name);
  return (
    <span
      className="label-chip"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        padding: "2px 8px",
        borderRadius: 999,
        background: c.bg,
        color: c.fg,
        fontSize: 11,
        fontWeight: 500,
        whiteSpace: "nowrap",
        lineHeight: 1.4,
      }}
    >
      {name}
      {onRemove && (
        <button
          type="button"
          aria-label={`Remove label ${name}`}
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          style={{
            background: "transparent",
            border: 0,
            color: c.fg,
            opacity: 0.6,
            cursor: "pointer",
            padding: 0,
            lineHeight: 1,
            fontSize: 13,
          }}
        >
          ×
        </button>
      )}
    </span>
  );
}
